import { render } from "./AddRetailerProduct.vue?vue&type=template&id=f15ab49e"
import script from "./AddRetailerProduct.vue?vue&type=script&lang=js"
export * from "./AddRetailerProduct.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__